import React from "react";
import { observer } from "mobx-react";
import { WeaTextarea } from "ecCom";

@observer
export default class TextareaItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  onBlur = value => {
    const { itemKey, onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(itemKey, value);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaTextarea
        {...bindObj.bind()}
        onChange={this.onChange}
        onBlur={this.onBlur}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/TextareaItem.js